/**
 * Reconnect overlay styling.
 *
 * A dim over the frozen game rather than a screen instead of it. What was on screen when the host
 * went is still the last true thing anybody saw, and covering it entirely would throw away the one
 * piece of context a player has while they wait.
 *
 * Pointer events are taken, unlike the notices: the button under here is the only thing worth
 * pressing while nothing is being simulated, and a shot fired into a frozen world is a shot spent
 * on nothing.
 */

import { injectCss } from '@/ui/cssInjector';

const CSS = `
.reconnect {
  position: fixed;
  inset: 0;
  z-index: 40;
  display: grid;
  gap: 16px;
  place-content: center;
  justify-items: center;
  background: rgba(11, 12, 14, 0.72);
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
  font: 500 15px/1.5 ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  color: #f2ede3;
  text-align: center;
}

.reconnect-line {
  max-width: min(90vw, 52ch);
  margin: 0;
  padding: 12px 18px;
  border-left: 3px solid #e8b34a;
  border-radius: 0 4px 4px 0;
  background: rgba(11, 12, 14, 0.86);
}

.reconnect-quiet {
  padding: 8px 16px;
  border: 1px solid rgba(242, 237, 227, 0.35);
  border-radius: 4px;
  background: none;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.reconnect-quiet:hover {
  border-color: #e8b34a;
}
`;

export function injectReconnectOverlayStyles(): () => void {
  return injectCss(CSS);
}
